import { action, decorate, observable, reaction } from 'mobx';
import { noteTypes } from '../enumerable/NoteTypes';
import { RootStore } from './RootStore';

export default class CommonStore {
    rootStore: RootStore;
    constructor(rootStore: RootStore) {
        this.rootStore = rootStore

        reaction(
            () => this.token,
            token => {
                if (token) {
                    window.localStorage.setItem('jwt', token);
                }
                else {
                    window.localStorage.removeItem('jwt');
                }
            }
        )
    }

    token: string | null = window.localStorage.getItem('jwt');
    appLoaded = false;

    setToken = (token: string | null) => {
        this.token = token;
    }
    setAppLoaded = () => {
        this.appLoaded = true;
    }
    getNoteOptions = (options: string[]) => {
        var SelectedNoteResults: {
            key: string;
            text: string;
            value: string;
        }[] = [];

        if (options.length === 0) {
            SelectedNoteResults = noteTypes;
        }
        else {
            options.forEach(element => {
                var noteType = noteTypes.find(el => el.key === element);

                if (noteType) {
                    SelectedNoteResults.push(
                        noteType
                    )
                }
            });
        }

        return SelectedNoteResults;
    }
}

decorate(CommonStore, {
    token: observable,
    appLoaded: observable,
    setToken: action,
    setAppLoaded: action,
    getNoteOptions: action
});